module.exports = __webpack_public_path__ + "reviews.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reviews.svg
// module id = 321
// module chunks = 2